// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "differencesContainer-BUJ7";
var _4 = "1.5rem";
var _5 = "firstSubTopicContainer-NBYP";
var _6 = "#dedede";
var _7 = "#adf";
var _8 = "1rem";
var _9 = "#bebebe";
var _a = "noResults -s2dD";
var _b = "routePathComparisonContainer-Vx83";
var _c = ".8rem";
var _d = "subTopic-u1Sm";
var _e = "toggleButton-zbO9";
var _f = "toggleButtonContainer-R8CA";
var _10 = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "differencesContainer", _4 as "extraLargeFontSize", _5 as "firstSubTopicContainer", _6 as "lightGrey", _7 as "lightblue", _8 as "mediumFontSize", _9 as "mediumLightGrey", _a as "noResults", _b as "routePathComparisonContainer", _c as "smallFontSize", _d as "subTopic", _e as "toggleButton", _f as "toggleButtonContainer", _10 as "unusedNodeColor" }
